<template>
	<div id='app' class="">
		<PageHeader />
		<loader />
		<router-view></router-view>
		<pageFooter />

	</div>
</template>
<script>

import PageHeader from './components/pageHeader.vue'
import pageFooter from './components/pageFooter.vue'
import loader from './components/loading.vue'
// Register ScrollTrigger

export default {
	metaInfo: {
		titleTemplate: 'Arabica'
	},
	components: { PageHeader, pageFooter, loader },
	mounted() {
		this.$store.dispatch('branches/fetchAll')
	},
}
</script>
<style lang='scss'>
@import './sass/app.scss';

@font-face {
	font-family: 'cairo';
	src: url('../public/fonts/Cairo-Regular.ttf') format('truetype');
}

* {
	font-family: cairo;
}

@keyframes spin {
	0% {
		transform: rotate(0deg);
	}

	100% {
		transform: rotate(360deg);
	}
}
.text-orange{
	color: #fcad4d;
}
.loader {
	border: 8px solid #f3f3f3;
	border-top: 8px solid #fcad4d;
	border-radius: 50%;
	width: 60px;
	height: 60px;
	animation: spin 2s linear infinite;
	margin: 0 auto;
}

a {
	cursor: pointer;
}
</style>
